<template>
  <div id="Digital-services">
    <div  class="social-nav filter-blur-50 border-bottom-white-1-50" >
      <div class="nameContainer" style="width: 100vw">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
<!--        <div class="arrowIcon">-->
<!--          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">-->
<!--        </div>-->
<!--        <router-link to="/roaming" class="d-flex">-->
<!--          <div class="bundleTitle">-->
<!--            {{digiltaTitle}}-->
<!--          </div>-->
<!--        </router-link>-->
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{mtnAppName}}</div>
      </div>
<!--      <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'checkContainer']" >-->
<!--        <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'filterForm']">-->
<!--          <div class="checkName">{{$t('popularBundles.showResults')}}</div>-->
<!--          <div class="check">-->
<!--            <input type="radio" id="pre" name="filter" value="0" checked @change="filter(0)" >-->
<!--            <label for="pre" class="radioLabel pre">{{$t('popularBundles.PrePaid')}}</label>-->
<!--          </div>-->
<!--          <div class="check">-->
<!--            <input type="radio" id="post" name="filter" value="1" @change="filter(1)" >-->
<!--            <label for="post" class="radioLabel post">{{$t('popularBundles.PostPaid')}}</label>-->
<!--          </div>-->
<!--        </form>-->
<!--      </div>-->
    </div>
    <div v-if="show && !error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));">
      <Loader />
    </div>
    <Error v-if="error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));"/>
    <div class="mtnRadioContainer" v-if="!show && !error" :class="[this.$lang === 'ar' ? 'right-dir' : '','']">
      <div class="Radiobackground" :class="[this.$lang === 'ar' ? 'leftPosition' : 'rightPosition','']">
        <div class="mainContainer">
<!--          <div class="mtnBack">-->
<!--            <router-link to="/">-->
<!--              <a>-->
<!--              <img src="../../assets/icons/backArrow.svg" style="cursor: pointer">-->
<!--              </a>-->
<!--            </router-link>-->
<!--          </div>-->
          <div class="mtnRadioText"  :class="[this.$lang === 'ar' ? 'rightPadding' : '','']">
            <div class="MTMRadioTitle d-flex">
              <div class="mainTitle" :class="[this.$lang === 'ar' ? 'arabic-bold' : '','']">{{mtnAppName}}</div>
            </div>
            <div class="mtnRadioImageSmall ">
              <img :src="background" class="d-img-sm w-100 radius-28 max-h">
            </div>
            <div class="priceContainer" v-if=" lang === 'en'"><span class="Price">{{price}}</span>
              <label class="switch" v-if="this.$store.state.selectedNumber !== null">
                <input @click="activate" v-model="active" type="checkbox">
                <span class="slider" :class="active ? '' : 'inactive'"></span>
                <div :style="{transform : active ? 'translateX(1.2em)' : 'translateX(0em)'}" id="border-ar" class="slider-border"></div>
              </label>
            </div>
            <div class="priceContainer right-align" v-if="lang === 'ar'"><span class="Price">{{price}}</span>
              <label class="switch" v-if="this.$store.state.selectedNumber !== null">
                <input @click="activate" v-model="active" type="checkbox">
                <span class="slider" :class="active ? '' : 'inactive'"></span>
                <div :style="{transform : active ? 'translateX(1.2em)' : 'translateX(0em)'}" id="border-en" class="slider-border"></div>
              </label>
            </div>
            <div class="radioDescription click-address" :class="lang === 'ar' ? 'right-align'  : ''" v-html="description">
<!--           {{description}}-->
            </div>
<!--            <div class="main-title font-18 mb-3" :class="lang === 'ar' ? 'arabicDir'  : ''">{{$t('digitalServices.download')}}</div>-->
<!--            <div  :class="lang === 'ar' ? 'rightButtons'  : ''">-->
<!--              <div :class="[$store.state.window < 380 && this.$lang === 'ar' ? 'right-dir' : '','buttons']">-->
<!--                <v-btn :class="[$store.state.window < 380 ? '' : 'mr-4' ,'flex-center download-btn']"  target="_blank" :href="appstore">-->
<!--                  <img class="icon" src="../../assets/icons/apple.svg">-->
<!--                  <div>-->
<!--                    <div class="download">{{$t('mtnApp.download')}}</div>-->
<!--                    <div class="site">App Store</div>-->
<!--                  </div>-->
<!--                </v-btn>-->
<!--                <v-btn class="flex-center download-btn"  target="_blank" :href="googleplay">-->
<!--                  <img class="icon" src="../../assets/icons/google.svg">-->
<!--                  <div>-->
<!--                    <div class="download">{{$t('mtnApp.git')}}</div>-->
<!--                    <div class="site">Google Play</div>-->
<!--                  </div>-->
<!--                </v-btn>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="mtnRadioImage">
            <img :src="background" class="radioImage">
          </div>
        </div>
<!--        <div class="yellowButton">-->
<!--          <additional-info-card/>-->
<!--        </div>-->
      </div>
    </div>
    <InsureActivation @close="close" @refresh="refresh" :id="Number(id)" method="post" type="services" v-if="ensure" :active="isActive" />
  </div>
</template>

<script>
// import AdditionalInfoCard from '../../components/cards/AdditionalInfoCard'
import $ from 'jquery'
import DigitalServiceRepository from '../../repositories/DigitalServicesRepository'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import InsureActivation from '../../components/dialogs/InsureActivation'
export default {
  name: 'index',
  components: { InsureActivation, Loader, Error },
  data () {
    return {
      active: false,
      ensure: false,
      lang: this.$lang,
      digitalServices: new DigitalServiceRepository(),
      digiltaTitle: this.$t('digitalServices.Title'),
      mtnAppName: '',
      description: '',
      filterType: 0,
      appIcon: '',
      background: '',
      id: '',
      base: gc.baseUrl,
      appstore: '',
      googleplay: '',
      price: '',
      show: true,
      error: false,
      isActive: false
    }
  },
  mounted () {
    this.getData()
    this.arabic()
    this.arabicRadio()
  },
  created () {
    this.id = this.$route.params.id
    this.$store.state.activeSectionNav = 0
    // this.$watch(() => {
    //   return this.$store.state.selectedNumber
    // }, (val) => {
    //   this.getData()
    // })
    // At change the main account, we should go to home page to reload services with selected gsm
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.goToHome()
    })
  },
  methods: {
    goToHome () {
      this.$router.push('/home')
    },
    activate () {
      this.ensure = true
      // this.active = this.info.main.isActive
    },
    close () {
      this.ensure = false
      this.active = this.isActive
    },
    refresh () {
      this.fetched = false
      this.error = false
      this.getData()
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav, .priceContainer').css('direction', 'rtl')
        $('.mainContainer').css('direction', 'rtl')
        $('.mtnRadioText').css('text-align', 'right')
        $('.checkName, .titleName, .MTMRadioTitle, .main-title, .Price, .month').css('font-family', 'Mtn-arabic-bold')
        $('.arrowIcon, .mtnBack').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.nav-tab .v-tab').css('transform', 'rotateY(180deg)')
        $('.checkContainer, .buttons').css('direction', 'ltr')
        $('.radioLabel').css('font-family', 'Mtn-regular')
        $('.bundleTitle').css('font-family', 'Mtn-arabic-regular')
        $('.Radiobackground').css('background-position-x', 'left')
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    async getData () {
      this.show = true
      try {
        const response = await this.digitalServices.getDigialServices(this.id, this.$store.state.selectedNumber)
        if (response.status === 200) {
          this.show = false
          this.description = response.data.html
          this.appIcon = this.base + response.data.icon
          this.background = this.base + '/' + response.data.image
          this.mtnAppName = response.data.title
          this.appstore = response.data.appleLink
          this.googleplay = response.data.link
          this.price = response.data.price === 0 ? this.$t('free') : response.data.price + this.$t('Bundles.sp')
          this.isActive = response.data.isActive === 1
          this.active = response.data.isActive === 1
          // console.log(this.background)
          this.fetched = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
    // filter (val) {
    //   this.filterType = val
    //   this.arabicRadio()
    // }
  }
}
</script>

<style scoped lang="scss">
  @import "src/assets/sass/main";
  #Digital-services{
    padding-top: 160px;
  }
  #Digital-services .social-nav{
  //background: rgba(212, 212, 212, 0.45);
  //background-color: $--light-white;
    height: 50px;
  //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .arabicBack{
    right: 4vw;
    left: unset !important;
    transform: rotateY(180deg);
  }
  .arabicSearch{
    right: 0 !important;
    left: unset !important;
  }
  #Digital-services .nameContainer{
    display: flex;
    padding: 0 4vw 0 3.2vw;
  }
  #Digital-services .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  #Digital-services .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  #Digital-services .bundleTitle{
    width: max-content;
    font-family: Mtn-regular;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .backArrow{
    width: 35px;
    height: 35px;
    margin-bottom: 50px;
  }
  .filterForm{
    display: flex;
  }
  .checkContainer{
    display: flex;
    justify-content: flex-end;
    width: 50vw;
    padding: 0 3vw;
    font-family: Mtn-regular;
  }
  .check{
    padding: 0 2vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkName{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Mtn-bold;
    font-style: italic;
  }
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label
  {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #1D1D1D;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2.5px solid $--yellow;
    border-radius: 100%;
    background: transparent;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 8px;
    height: 8px;
    background: $--yellow;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    font-weight: bold;
  }
  input[type="radio"]:checked+label {
    font-family: Mtn-bold;
    /*font-family: Mtn-arabic-bold;*/
  }
  @media screen and (max-width: 650px) {
    .checkName {
      display: none;
    }
  }
  @media screen and (max-width: 950px) {
    /*.homeIcon,*/
    /*.arrowIcon,*/
    /*#Digital-services .bundleTitle,*/
    /*.checkName{*/
    /*  display: none;*/
    /*}*/
    /*.nameContainer{*/
    /*  width: 40vw !important;*/
    /*}*/
    .checkContainer{
      width: 60vw !important;
    }
  }
  .mtnRadioContainer{
    min-height: calc(100vh - (170px + 277.2px));
    background-image: linear-gradient(to bottom, #F2F2F2, #e1e1e1);
  }
  .Radiobackground{
    min-height: calc(100vh - (170px + 277.2px));
    background-image: url('../../assets/icons/digitalServices.svg');
    background-position-x: right;
  }
  .mainContainer{
    display: flex;
    position: relative;
  }
  .radioImage{
    //height: 280px;
    //width: 500px;
    //border-radius: 15px;
    height: auto;
    width: 100% !important;
    border-radius: 28px;
    //max-width: 532px !important;
  }
  .mtnRadioText {
    //width: 70%;
    width: 58.33333333%;
    padding: 60px 4vw;
    text-align: left;
  }
  .mtnRadioImage {
    /*width: 40%;*/
    width: 41.66666667%;
    padding: 60px 3vw;
  }
  .arabicDir{
    text-align: right !important;
  }
  .rightButtons{
    display: flex;
    justify-content: right!important;
  }
  .main-title {
    font-style: italic;
  }
  .v-btn {
    text-transform: initial!important;
  }
  .download {
    font-size: 10px!important;
  }
  .icon {
    margin-right: 7px;
    width: 22px;
  }
  .buttons{
    display: flex;
  }
  .mtnBack{
    position: absolute;
    top: 30px;
    padding: 0 4vw;
  }
  .MTMRadioTitle{
    font-size: 30px;
    color: $--yellow;
    font-family: Mtn-bold;
    padding: 15px 0;
  }
  .radioIcon{
    /*height: 90px;*/
    /*width: 80px;*/
    width: 44px;
    height: 52px;
  }
  .radioDescription{
    /*padding: 0 2vw*/
  }
  .mtnRadioImageSmall{
    display: none;
  }
  @media screen and (max-width: 992px) {
    #Digital-services .mtnRadioImageSmall {
      display: block;
      padding-bottom: 2vh;
      max-width: 484px !important;
    }
    .mtnRadioImage{
      display: none;
    }
    .mtnRadioText {
      width: 100%;
    }
    }
  .yellowButton{
    padding: 50px 2vw;
  }
  @media screen and (max-width: 381px) {
    .buttons {
      display: block;
    }
  }
  #Digital-services .theme--light.v-btn.v-btn--has-bg {
    background: transparent !important;
  }
  .mainTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*padding: 0 20px;*/
  }
  .priceContainer{
    padding-bottom: 25px;
    font-style: italic;
  }
  .Price{
    font-family: Mtn-bold;
    font-size: 20px;
    font-style: normal;
  }
  .month{
    font-family: Mtn-bold;
    font-size: 12px;
  }
  .leftPosition {
    background-position-x: left;
  }
  .rightPosition {
    background-position-x: right;
  }
  .rightPadding{
    padding: 60px 5vw !important
  }
  label {
    margin: 0 1rem;
  }
  /*--- switch button ----*/
  /* The switch - the box around the slider */
  .switch {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 2.8em;
    height: 1.5em;
    border-radius: 50px;
    box-shadow: 10px 10px 20px rgba(0,0,0,0.08)
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    border: 2px solid $--yellow;
    border-radius: 50px;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .inactive {
    border: 2px solid #6A6A6A;
  }
  .inactive.slider:before {
    background-color: #6A6A6A;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 1em;
    width: 1em;
    left: 0.2em;
    bottom: 0.14em;
    background-color: $--yellow;
    border-radius: inherit;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  }
  .slider-border {
    height: 1em;
    width: 1em;
    border: .8px solid #ffffff;
    border-radius: 50%;
    position: absolute;
    left: 0.32em;
    bottom: 0.25em;
    filter: blur(1px);
    transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
    cursor: pointer;
  }

  .switch input:checked + .slider:before {
    transform: translateX(1.2em);
  }
  /*---------------------------------*/
</style>
